import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("ApplicationStore");

const urls = {
  applicationList: `/bnpl/application/merchant`,
  applicationListWithQuery: (query) => `/bnpl/application/merchant?${query}`,
  application: (id) => `/bnpl/application/merchant/${id}`,
  prescoreListWithQuery: (query) =>
    `/bnpl/pre-score/merchant/pre-scores/search?${query}`,
  prescore: (id) => `/bnpl/application/merchant/${id}`,
  getFlow: (id) => `/bnpl/application/merchant/flow/${id}`,
  bnplApplicationStatus: (id) => `/bnpl/application/${id}/update-status`,
  bnplApplicationDocumentsForMerchant: (id) =>
    `/bnpl/application/merchant/${id}/documents`,
  exportDealCsv: "/bnpl/application/merchant/export-deal/csv",
  exportTransactionCsv: "/bnpl/application/merchant/export-transactions/csv",
};

const initState = () => {
  return {
    application: {},
    applicationList: {},
    prescore: {},
    prescoreList: {},
    flows: {},
    documents: {},
  };
};

const actions = {
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.application(id));
      data.dynamicData = JSON.parse(data.dynamicData);
      commit("saveApplication", { data: data, id: id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let url = urls.applicationList;
      if (query) {
        url = urls.applicationListWithQuery(query);
      }
      let { data } = await axios.get(url);
      commit("saveApplicationList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchPrescore: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.application(id));
      data.dynamicData = JSON.parse(data.dynamicData);
      commit("savePrescore", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchPrescoreList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.prescoreListWithQuery(query));
      commit("savePrescoreList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchDocuments: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(
        urls.bnplApplicationDocumentsForMerchant(id)
      );
      commit("saveDocuments", {
        id,
        data,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchFlow: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getFlow(id));
      commit("saveFlow", {
        id: id,
        data: data.steps.sort((a, b) => a.rowIndex - b.rowIndex),
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  updateStatus: async ({}, { status, result, id }) => {
    try {
      const axios = await network.connection();
      await axios.patch(urls.bnplApplicationStatus(id), {
        status,
        result,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  exportDealCsv: async () => {
    try {
      const axios = await network.connection();
      let blob = await axios.get(urls.exportDealCsv, {
        responseType: "blob",
        timeout: 120000,
      });
      return blob.data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  exportTransactionCsv: async () => {
    try {
      const axios = await network.connection();
      let blob = await axios.get(urls.exportTransactionCsv, {
        responseType: "blob",
        timeout: 120000,
      });
      return blob.data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveApplication: (state, { data, id }) => {
    Vue.set(state.application, id, data);
  },
  saveApplicationList: (state, data) => {
    Vue.set(state, "applicationList", data);
  },
  savePrescore: (state, data) => {
    Vue.set(state, "prescore", data);
  },
  savePrescoreList: (state, data) => {
    Vue.set(state, "prescoreList", data);
  },
  saveFlow: (state, { id, data }) => {
    Vue.set(state.flows, id, data);
  },
  saveDocuments: (state, { id, data }) => {
    Vue.set(state.documents, id, data);
  },
};

const getters = {
  get: (state) => (id) => {
    return state.application[id];
  },
  list: (state) => {
    return state.applicationList;
  },
  getPrescore: (state) => {
    return state.prescore;
  },
  listPrescores: (state) => {
    return state.prescoreList;
  },
  getFlow: (state) => (id) => {
    return state.flows[id];
  },
  getDocuments: (state) => (id) => {
    return state.documents[id];
  },
};
export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
